import { ValidatorFn, AbstractControl } from '@angular/forms';

export function currentPasswordRequiredValidator(newPasswordControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl) => {
        const newPassword = newPasswordControl?.value;
        const currentPassword = control.value;

        // If there's a new password but no current password, it's required
        if (newPassword?.trim() && !currentPassword?.trim()) {
            return { required: true };
        }

        return null;
    };
}
